import {
  Box,
  Button,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNotFoundCandidates } from "../../hooks/useNotFoundCandidates";

type CampaignType = "MIGRATION" | "FIDELIZATION";
type DataSourceType = "" | "CSV" | "INTERNAL_SEARCH";

interface NotFoundCandidatesModalProps {
  open: boolean;
  onClose: () => void;
  module: CampaignType;
  dataSource: DataSourceType;
}

export const NotFoundCandidatesModal = ({
  open,
  onClose,
  module,
  dataSource,
}: NotFoundCandidatesModalProps) => {
  const { data, loading } = useNotFoundCandidates(module, open, dataSource);

  const columns: GridColDef[] = [
    {
      field: "identification",
      headerName: "Identificación",
      flex: 1,
      sortable: false,
    },
    {
      field: "customerName",
      headerName: "Nombre",
      flex: 1.4,
      sortable: false,
    },
    {
      field: "planName",
      headerName: "Plan",
      flex: 1,
      sortable: false,
    },
    {
      field: "zoneName",
      headerName: "Zona",
      flex: 1,
      sortable: false,
    },
    {
      field: "equipmentName",
      headerName: "Equipo",
      flex: 1.2,
      sortable: false,
    },
    {
      field: "installationDate",
      headerName: "Fecha instalación",
      flex: 1,
      sortable: false,
    },
    {
      field: "reason",
      headerName: "Motivo",
      flex: 1.5,
      sortable: false,
    },
  ];

  const titleModule = module === "MIGRATION" ? "Migración" : "Fidelización";
  const titleSource =
    dataSource === "CSV" ? "Carga CSV/XLSX" : "Búsqueda interna";

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: "92%",
          maxWidth: 1200,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          mx: "auto",
          my: "5vh",
          height: "85vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Stack spacing={3} sx={{ height: "100%" }}>
          <Box>
            <Typography variant="h5" fontWeight={700}>
              Candidatos no elegibles - {titleModule}
            </Typography>

            <Typography variant="body2" color="text.secondary" mt={1}>
              Fuente de datos: {titleSource}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary">
            Aquí se muestran los registros que no pueden crear ticket porque no
            fueron encontrados en el módulo de tickets.
          </Typography>

          <Box sx={{ flex: 1, minHeight: 0 }}>
            <DataGrid
              rows={data}
              columns={columns}
              getRowId={(row) => row.candidateId}
              loading={loading}
              disableColumnMenu
              disableColumnFilter
              disableColumnSelector
              hideFooterSelectedRowCount
              pageSizeOptions={[10, 20, 50]}
              localeText={{
                noRowsLabel: "No hay candidatos para mostrar",
                footerRowSelected: () => "",
                MuiTablePagination: {
                  labelRowsPerPage: "Filas por página",
                  labelDisplayedRows: ({ from, to, count }) =>
                    `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
                },
              }}
              sx={{
                border: 0,
                "& .MuiDataGrid-columnHeaders": {
                  borderBottom: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                  outline: "none !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  outline: "none !important",
                },
                "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                  {
                    outline: "none !important",
                  },
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                  outline: "none !important",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
              }}
            />
          </Box>

          <Box display="flex" justifyContent="flex-end">
            <Button variant="outlined" onClick={onClose}>
              Cerrar
            </Button>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};
